import type {
	HandleAutocompleteSearch,
	HandleSearchPressed,
} from '@features/customers/interfaces/search.interfaces';
import { ClienteSuite } from '@interfaces/firestore-documents.interfaces';
import type {
	ChangeEventHandler,
	ClipboardEventHandler,
	KeyboardEventHandler,
	MouseEventHandler,
} from 'react';

export function handleInputChange(
	handleAutocompleteSearch: HandleAutocompleteSearch,
	verifyText: (str: string) => boolean
): ChangeEventHandler<HTMLInputElement> {
	return function (e) {
		const { value } = e.target;

		if (value.length === 0 || verifyText(value)) {
			handleAutocompleteSearch(value);
		} else {
			e.preventDefault();
		}
	};
}

export function handleInputKeyDown(
	needAutocomplete: boolean,
	setNeedAutocomplete: (status: boolean) => void
): KeyboardEventHandler<HTMLInputElement> {
	return function (e) {
		if (e.key === 'Backspace' && !needAutocomplete) {
			setNeedAutocomplete(true);
		}
	};
}

export function handleInputKeyPress(
	handleSearchPressed: HandleSearchPressed,
	verifyText: (str: string) => boolean
): KeyboardEventHandler<HTMLInputElement> {
	return function (e) {
		if (!verifyText(e.key) && e.key !== 'Enter' && e.key !== 'Backspace') {
			e.preventDefault();
			return;
		}

		if (e.key === 'Enter') {
			handleSearchPressed();
		}
	};
}

export function handleInputPaste(
	setNeedAutocomplete: (status: boolean) => void,
	verifyText: (str: string) => boolean
): ClipboardEventHandler<HTMLInputElement> {
	return function (e) {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		const textToCopy = (e.clipboardData || (window as any).clipboardData).getData('text');
		if (!textToCopy || !verifyText(textToCopy)) {
			e.preventDefault();
			return;
		}

		setNeedAutocomplete(false);
	};
}

export function handleSearchOptionClick(
	handleSearchPressed: HandleSearchPressed,
	data: ClienteSuite
): MouseEventHandler<HTMLDivElement> {
	return function () {
		handleSearchPressed(data);
	};
}

export function handleSearchOptionKeyPress(
	handleSearchPressed: HandleSearchPressed,
	data: ClienteSuite
): KeyboardEventHandler<HTMLDivElement> {
	return function (e) {
		if (e.key === 'Enter') {
			handleSearchPressed(data);
		}
	};
}
